export default __webpack_public_path__ + "static/media/logo.707ad87b.png";